import { observer } from 'mobx-react-lite'
import { useLocation, useParams } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout } from 'entities/ExportRouters'
import { NewInboxRoutes } from 'pages/settings/pages/inboxes/route/type'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'

export const BuyNumberAccessLayout = observer(() => {
  const location = useLocation()
  const { id } = useParams()

  return (
    <AccessLayout
      name={EnumAccessPageKeys.inbox_page}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: InboxesPath.inboxNumbers(Number(id)),
        })
      }}
      onAccessSuccess={() => {
        if (!location.pathname.includes(NewInboxRoutes.chooseNumber)) {
          uiStore.changeRouteViaVue({
            path: InboxesPath.inboxNumbersBuyNumber(Number(id)),
          })
        }
      }}
    />
  )
})
